export function getYMDDate(date){
	return date.getFullYear()+'-'+('0' + (date.getMonth()+1)).slice(-2)+'-'+('0' + (date.getDate())).slice(-2);
}

export function buildDateFromString(string, format){
	string = string+'';
	format = (typeof format === 'undefined') ? 'yyyy-mm-dd hh:ii:ss' : format;
	const parsedFormat = parseFormatStructure(format);
	const parsedString = parseStringByFormat(string, parsedFormat);

	if(parsedString.y === false || parsedString.m === false || parsedString.d === false)
		return false;

	const date = new Date(parsedString.y, parsedString.m-1,parsedString.d);

	if(parsedString.h !== false)
		date.setHours(parsedString.h);

	if(parsedString.i !== false)
		date.setMinutes(parsedString.i);

	if(parsedString.s !== false)
		date.setSeconds(parsedString.s);

	return date;
}

function parseStringByFormat(string, parsedFormat){
	const parsed = {y: false, m: false, d: false, h: false, i:false, s:false};
	const keys = Object.keys(parsedFormat);
	for(let i = 0; i < keys.length; i++){
		const result = string.substring(parsedFormat[keys[i]].start,parsedFormat[keys[i]].end+1);
		if(result !== '')
			parsed[keys[i]] = Number(result);
	}
	return parsed;
}

function parseFormatStructure(format){
	const structure = {};
	const acceptedChars = 'ymdhis';
	for (let i = 0; i < format.length; i++) {
		const char = format.charAt(i);
		if(acceptedChars.indexOf(char) !== -1){
			if(typeof structure[char] === 'undefined'){
				structure[char] = {
					start: i,
					end: i
				}
			} else {
				structure[char].end = i;
			}
		}
	}

	return structure;
}
